export default {
  office: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Zyra dhe klinika',
    hero: {
      eyebrow: 'Zyra dhe klinika',
      title: 'Mbikëqyrje diskrete për mjediset e punës',
      lead: 'Recepsioni, korridoret, zonat e ndjeshme – planifikojmë sisteme kamerash që mbrojnë pa shqetësuar punonjësit apo pacientët.',
    },
    areas: {
      title: 'Fushat e përdorimit në zyra dhe klinika',
      lead: 'Zyrat dhe klinikat moderne kanë nevojë për teknologji sigurie jo ndërhyrëse. I integrojmë kamerat me delikatesë në arkitekturë.',
      items: {
        '0': { title: 'Recepsioni', desc: 'Përshtypja e parë dhe pika e parë e mbikëqyrjes. Kamerat në recepsion dokumentojnë vizitorët dhe sigurojnë hyrjen.' },
        '1': { title: 'Korridoret', desc: 'Korridoret e gjata shpesh janë pika të verbëra. Kamera kompakte tavani i mbyllin boshllëqet pa u ndjerë.' },
        '2': { title: 'Sallat e mbledhjeve', desc: 'Jo çdo mbledhje duhet regjistruar. I konfigurojmë kamerat të kapin vetëm zonat relevante.' },
        '3': { title: 'Dhoma e serverëve', desc: 'Dhoma ku ndodhen të dhënat tuaja meriton vëmendje të veçantë. Hyrja dhe aktiviteti regjistrohen me besueshmëri.' },
        '4': { title: 'Recepsioni i klinikës', desc: 'Në klinika ka rëndësi diskrecioni. Montojmë kamera të matura që nuk shqetësojnë pacientët.' },
        '5': { title: 'Parkingu dhe hyrja', desc: 'Parkingjet dhe hyrjet e jashtme janë veçanërisht të rrezikuara natën. Kamera rezistente me shikim nate ruajnë.' },
      },
    },
    access: {
      eyebrow: 'Qasja dhe kontrolli',
      title: 'Kush mund të shohë çfarë?',
      lead: 'Një sistem kamerash në zyrë pranohet vetëm nëse të drejtat janë të qarta. Konfigurojmë të drejta të diferencuara dhe dokumentojmë çdo përdorim.',
      items: {
        '0': { title: 'Menaxhimi i përdoruesve', desc: 'Çdo person merr pikërisht të drejtat që i duhen – nga pamja live te riprodhimi i regjistrimeve.' },
        '1': { title: 'Maskimi i zonave private', desc: 'Zona si dhomat e pushimit apo të zhveshjes fshihen teknikisht – në kamerë ose regjistrues.' },
        '2': { title: 'Regjistri i ngjarjeve', desc: 'Kush shikoi çfarë dhe kur? Një regjistër i plotë qasjeje siguron kontroll të gjurmueshëm.' },
      },
    },
    privacy: {
      eyebrow: 'Mbrojtja e të dhënave',
      title: 'Mbrojtja e të dhënave në punë',
      lead: 'Punonjësit dhe vizitorët gëzojnë mbrojtje të veçantë. E zbatojmë mbikëqyrjen në mënyrë të ligjshme dhe të drejtë – dhe ju këshillojmë për dokumentimin e nevojës.',
      list: {
        '0': 'Regjistrim vetëm aty ku është operacionalisht i nevojshëm',
        '1': 'Tabela informuese për punonjësit dhe vizitorët',
        '2': 'Asnjë mbikëqyrje e dhomave të zhveshjes, tualeteve apo pushimit',
        '3': 'Qasje në regjistrime vetëm për persona të autorizuar',
        '4': 'Dokumentim i nevojës operacionale',
      },
      note: 'Shënim: mbikëqyrja e vendeve të punës i nënshtrohet kërkesave të rrepta ligjore. Ju këshillojmë teknikisht, pa zëvendësuar këshillën ligjore.',
    },
    cta: {
      title: 'Diskret. Me respekt për privatësinë. I besueshëm.',
      lead: 'E planifikojmë sistemin e zyrës ose klinikës që të mbrojë pa penguar në përditshmëri. Pa detyrim dhe në mënyrë transparente.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
};